import { css } from '@emotion/css';
import { ColorConstant } from 'src/styles';

export const mSwitch = css`
  &:hover:not(:focus) {
    background-color: ${ColorConstant.BRAND5} !important;
  }
`;
